module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_delete-1316ce76fc0acd3d7c466c65c5bf3128.svg";